import { NestedHome } from '@habity/types';
import { HomeDataBuilder } from './data-builder';
import { createLandsFields } from './lands-fields';

export const getLandsData = (home: NestedHome) => {
  if (!home.provider_data || !home.provider_type) return [];

  const dynamicFields = createLandsFields({ home });
  
  return new HomeDataBuilder(home)
    .addFields(dynamicFields)
    .build();
};

export const getLandsDescription = (home: NestedHome) => {
  const { property_designation } = home?.address || {};
  return property_designation
    ? `Marker för ${property_designation}`
    : 'Marker';
};
